/**
 * @generated SignedSource<<fb9fb5e70a34324de272d1d972c091b0>>
 * @relayHash 1103d76ea8b90885c66551ab3e903e85
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID fa393a32d2bf9a553a017b6f1a594c7deb364373220d688ce2f3bbbef3927335

import type { ConcreteRequest, Query } from 'relay-runtime';
export type preloadContentSmartLinksForDraftQuery$variables = {
  contentId: string;
};
export type preloadContentSmartLinksForDraftQuery$data = {
  readonly confluence_contentSmartLinksForDraft: {
    readonly nodes: ReadonlyArray<{
      readonly __typename: string;
      readonly title: string | null | undefined;
      readonly url: string;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type preloadContentSmartLinksForDraftQuery = {
  response: preloadContentSmartLinksForDraftQuery$data;
  variables: preloadContentSmartLinksForDraftQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      }
    ],
    "concreteType": "PaginatedSmartLinkList",
    "kind": "LinkedField",
    "name": "confluence_contentSmartLinksForDraft",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "__typename"
          },
          {
            "kind": "ScalarField",
            "name": "url"
          },
          {
            "kind": "ScalarField",
            "name": "title"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "preloadContentSmartLinksForDraftQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "preloadContentSmartLinksForDraftQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1103d76ea8b90885c66551ab3e903e85",
    "id": "fa393a32d2bf9a553a017b6f1a594c7deb364373220d688ce2f3bbbef3927335",
    "metadata": {},
    "name": "preloadContentSmartLinksForDraftQuery",
    "operationKind": "query",
    "text": "query preloadContentSmartLinksForDraftQuery($contentId:ID!){confluence_contentSmartLinksForDraft(id:$contentId){nodes{__typename,url,title}}}"
  }
};
})();

(node as any).hash = "ea9e9fcd1a20d4ef72bdbf89399dcb8c";

export default node;
